/* eslint-disable react/jsx-no-useless-fragment */
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useIntercom } from 'react-use-intercom';
import Smartlook from 'smartlook-client';
import GlobalLoader from '@/components/common/GlobalLoader/GlobalLoader';
import useWhiteLabelService from './layout/login/hooks/useWhiteLabel.service';
import { selectSelectedLanguage } from './pages/store/language/selectors';
import { selectGlobalLoaderState } from './pages/store/ui/selectors';
import { useAuthHydration } from './services/auth/authHydrator';
import VITE_SMARTLOOK_KEY from './utils/envinornmentKey';

interface IAppInitializerProps {
  children: React.ReactNode;
}

const AppInitializer = ({ children }: IAppInitializerProps) => {
  const { getWhiteLabelFromLocalStorage, validateWhiteLabel } =
    useWhiteLabelService();
  const { i18n } = useTranslation();
  const globalLoading = useSelector(selectGlobalLoaderState);
  const { language } = useSelector(selectSelectedLanguage);
  const { boot } = useIntercom();

  useAuthHydration();

  useEffect(() => {
    i18n.changeLanguage(language.toLowerCase());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  useEffect(() => {
    if (VITE_SMARTLOOK_KEY) {
      Smartlook.init(VITE_SMARTLOOK_KEY);
    }
    validateWhiteLabel();
    getWhiteLabelFromLocalStorage();
    boot();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (globalLoading.loading) {
    return <GlobalLoader />;
  }

  return <>{children}</>;
};

export default AppInitializer;
